import { render, staticRenderFns } from "./numbers.vue?vue&type=template&id=47f2be18&scoped=true&lang=pug&"
import script from "./numbers.vue?vue&type=script&lang=js&"
export * from "./numbers.vue?vue&type=script&lang=js&"
import style0 from "./numbers.vue?vue&type=style&index=0&id=47f2be18&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f2be18",
  null
  
)

component.options.__file = "numbers.vue"
export default component.exports